import React from 'react';
// ---------------  For Ui ----------------------------------
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
// ---------------  For Redux ----------------------------------
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';


const style = {
  rounded: {
    padding: 20, background: '#fff'
  },
  count: {
    padding: '10px 15px',
    boxShadow: '1px 1px 5px -2px rgba(0,0,0.9)',
    display: 'inline-block',
    borderRadius: 7,
    fontWeight: 'bold',
    background: 'rgba(0,0,0,.05)'
  }
}


class AddInput extends React.PureComponent {

  state = {
    id: '',
    title: '',
    defaultValue: '',
    isRequired: true,
    showOn: '',
    type:''
  }

  componentDidMount() {
    const { id, title, defaultValue, isRequired, showOn } = this.props;
    this.setState({ id, title, defaultValue, isRequired, showOn });
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  handleToggle = (e) => {
    this.setState({
      [e.target.id]: !this.state[e.target.id]
    })
  }

  render() {
    const { InputTypes, showOnOptions, count, deleteInput } = this.props;
    const { id, title, defaultValue, isRequired, showOn } = this.state;

    return <div class="MuiPaper-elevation1 MuiPaper-rounded" style={style.rounded}>
      <span style={style.count}>{count + 1}</span>
      <div style={{ textAlign: "right", marginTop: -40 }}>
        <IconButton aria-label="add to favorites" onClick={() => { deleteInput(count) }}>
          <DeleteIcon />
        </IconButton>
      </div>

      <FormControl margin="normal" required fullWidth>
        <InputLabel htmlFor="path">Input Title</InputLabel>
        <Input
          onChange={this.handleChange}
          name="title"
          type="text"
          id="title"
          value={title}
        />
      </FormControl>

      <FormControl margin="normal" required fullWidth>
        <Autocomplete
          id="type"
          onChange={(event, newValue) => {
            if (newValue && newValue.inputValue) {
              this.setState({ type: newValue.inputValue })
            }
          }}
          options={InputTypes}
          getOptionLabel={(option) => option}
          defaultValue='text'
          renderInput={(params) => <TextField {...params} label={'Input Type*'} variant="standard" />}
        />
      </FormControl>

      <FormControl margin="normal" required fullWidth>
        <InputLabel htmlFor="path">Input Id</InputLabel>
        <Input
          onChange={this.handleChange}
          name="id"
          type="text"
          id="id"
          value={id}
        />
      </FormControl>

      <FormControl margin="normal" fullWidth>
        <InputLabel htmlFor="path">Default Value</InputLabel>
        <Input
          onChange={this.handleChange}
          name="defaultValue"
          type="text"
          id="defaultValue"
          value={defaultValue}
        />
      </FormControl>


      <FormControl margin="normal" required fullWidth>
        <FormControlLabel
          control={<Switch id="isRequired" checked={isRequired} onChange={this.handleToggle} name="isRequired" />}
          label="Required"
        />
      </FormControl>


      <FormControl margin="normal" required fullWidth>
        <Autocomplete
          id="showOn"
          onChange={(event, newValue) => {
            if (newValue && newValue.inputValue) {
              this.setState({ showOn: newValue.inputValue })
            }
          }}
          defaultValue='content'
          options={showOnOptions}
          getOptionLabel={(option) => option}
          renderInput={(params) => <TextField {...params} label={'Show on*'} variant="standard" />}
        />
      </FormControl>

    </div>
  }
}

export default AddInput;